import {
  discoveryApiRef,
  errorApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { useAsyncFn } from 'react-use';

type UpdateUserRoleParams = {
  email: string;
  role: string;
  researchPanelInterest: boolean;
};

type UpdateUserRoleResponse = {
  email: string;
  role?: string;
  research_panel_interest?: boolean;
};

export const useUpdateUserRole = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const { fetch } = useApi(fetchApiRef);
  const errorApi = useApi(errorApiRef);

  const updateUserRole = async ({
    email,
    role,
    researchPanelInterest,
  }: UpdateUserRoleParams): Promise<UpdateUserRoleResponse> => {
    const baseUrl = await discoveryApi.getBaseUrl('user-profile-info');
    const response = await fetch(
      `${baseUrl}/users/${encodeURIComponent(email)}/role`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          role,
          research_panel_interest: researchPanelInterest,
        }),
      },
    );

    if (!response.ok) {
      const patchError = new Error(
        `Failed to update role and research panel interest`,
      );
      errorApi.post(patchError);
      throw patchError;
    }

    return (await response.json()) as UpdateUserRoleResponse;
  };

  const [state, updateUserRoleAsync] = useAsyncFn(updateUserRole, []);

  return {
    ...state, // loading, error, value
    updateUserRole: updateUserRoleAsync,
  };
};
